$(function () {
  $(".js-ajax-request-on-click").on("click", function (event) {
    sendDataAndTriggerSaveResponseClasses(event);
  });

  $(".js-ajax-request-on-keyup-with-debounce").on("keyup", function (event) {
    debounceAndSendDataAndTriggerSaveResponseClasses(event);
  });

  $(".js-ajax-request-on-change").on("change", function (event) {
    sendDataAndTriggerSaveResponseClasses(event);
  });

  let timeout;
  function sendDataAndTriggerSaveResponseClasses(event) {
    const { modelName, fieldName, url, method } = $(event.target).data();
    const data = {
      [modelName]: {
        [fieldName]: $(event.target).val(),
      },
    };
    window.clearTimeout(timeout);
    $.ajax({
      type: method,
      url: url,
      data: data,
      dataType: "JSON",
      success: function (data) {
        $(event.target).siblings().addClass("request-update-saved-show");
        timeout = window.setTimeout(function () {
          $(event.target).siblings().removeClass("request-update-saved-show");
        }, 300);
      },
      error: function (jqXhr, textStatus, errorThrown) {
        alert(errorThrown);
      },
    });
  }

  function debounce(func, timeout = 500) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  const debounceAndSendDataAndTriggerSaveResponseClasses = debounce((event) =>
    sendDataAndTriggerSaveResponseClasses(event)
  );
});
